"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeContext = void 0;

var _createReactContext = _interopRequireDefault(require("@ant-design/create-react-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreeContext = (0, _createReactContext.default)(null);
exports.TreeContext = TreeContext;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree/lib/contextTypes.js
// module id = 840
// module chunks = 0